// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PromptBox styles - fully scoped to .prompt-box */
.prompt-box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: transparent;
  border: none;
}

.prompt-box--dragging {
  background: transparent;
  border: none;
}

.prompt-box-form {
  width: 100%;
  max-width: 700px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.prompt-box-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.prompt-box-label {
  font-size: 11px;
  font-weight: 700;
  color: var(--color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.prompt-box-field {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
}

.prompt-box--resizable .prompt-box-field {
  position: relative;
  gap: 0;
  /* Top/sides stay matched; add a little extra room before the bottom border */
  padding: 14px 14px 18px;
}

.prompt-box--resizable .prompt-box-textarea {
  /* Tight line box so the first line's ink aligns closer to the left inset */
  line-height: 1;
  padding: 0;
}

.prompt-box-resize-handle {
  position: absolute;
  /* Match the field padding on all sides (absolute positioning is padding-box relative) */
  top: 0;
  left: 0;
  right: 0;
  width: auto;
  height: 8px;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: ns-resize;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
}

.prompt-box-resize-grip {
  width: 36px;
  height: 3px;
  border-radius: 999px;
  background: var(--color-border-input);
  transition: background 0.15s ease;
}

.prompt-box-resize-handle:hover .prompt-box-resize-grip,
.prompt-box-resize-handle:focus-visible .prompt-box-resize-grip {
  background: var(--color-text-secondary);
}

.prompt-box-field:focus-within {
  border-color: var(--color-text-secondary);
}

.prompt-box-input {
  position: relative;
  display: flex;
  flex-direction: column;
}

.prompt-box-textarea-wrapper {
  position: relative;
}

.prompt-box-textarea {
  width: 100%;
  min-height: 120px;
  max-height: 240px;
  padding: 0;
  border: none;
  border-radius: 0;
  background: transparent;
  font-size: 14px;
  line-height: 1.6;
  color: var(--color-text-primary);
  font-family: inherit;
  resize: none;
  outline: none;
  overflow-y: hidden;
  transition: border-color 0.15s ease, opacity 0.15s ease;
}

.prompt-box-textarea.enhancing {
  opacity: 0.6;
  pointer-events: none;
}

.prompt-box-enhancing-overlay {
  position: absolute;
  inset: 0;
  border-radius: 4px;
  overflow: hidden;
  pointer-events: none;
  z-index: 1;
}

.prompt-box-enhancing-shimmer {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.08) 20%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(255, 255, 255, 0.08) 80%,
    transparent 100%
  );
  background-size: 200% 100%;
  animation: promptBoxEnhanceShimmer 1.5s ease-in-out infinite;
}

@keyframes promptBoxEnhanceShimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.prompt-box-textarea:focus {
  outline: none;
}

.prompt-box-textarea::placeholder {
  color: var(--color-text-secondary);
}

.prompt-box-actions {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 10px;
}

.prompt-box-actions > * {
  flex-shrink: 0;
}

.prompt-box-actions .model-selector {
  flex-shrink: 0;
}

.prompt-box-actions .model-selector-trigger {
  height: 32px;
  padding: 0 10px;
  border-radius: 3px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 12px;
  font-weight: 600;
}

.prompt-box-actions .model-selector-trigger:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
  border-color: var(--color-text-secondary);
}

.prompt-box-actions .model-selector-content {
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  box-shadow: none;
}

.prompt-box-actions .model-selector-item {
  border-radius: 2px;
}

.prompt-box-actions .model-selector-item:hover,
.prompt-box-actions .model-selector-item[aria-selected='true'] {
  background: var(--color-bg-user-bubble);
}

.asset-aspect-ratio-picker {
  flex-shrink: 0;
}

.asset-aspect-ratio-trigger {
  height: 32px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 0 9px;
  border-radius: 3px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.15s ease;
}

.asset-aspect-ratio-trigger:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
  border-color: var(--color-text-secondary);
}

.asset-aspect-ratio-trigger:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.asset-aspect-ratio-swatch,
.asset-aspect-ratio-item-swatch {
  display: block;
  width: 18px;
  max-height: 18px;
  min-height: 9px;
  border: 1px solid currentColor;
  border-radius: 2px;
  opacity: 0.72;
  background: transparent;
}

.asset-aspect-ratio-value {
  min-width: 28px;
  text-align: left;
}

.asset-aspect-ratio-icon {
  color: var(--color-text-secondary);
  transition: transform 0.15s ease;
}

.asset-aspect-ratio-icon-open {
  transform: rotate(180deg);
}

.asset-aspect-ratio-content {
  min-width: 190px;
  padding: 4px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.16);
  z-index: 10000;
}

.asset-aspect-ratio-item {
  display: grid;
  grid-template-columns: 22px minmax(0, 1fr) 16px;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: 2px;
  color: var(--color-text-primary);
  cursor: pointer;
  outline: none;
}

.asset-aspect-ratio-item:hover,
.asset-aspect-ratio-item[data-highlighted] {
  background: var(--color-bg-user-bubble);
}

.asset-aspect-ratio-item-copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.asset-aspect-ratio-item-label {
  font-size: 12px;
  font-weight: 700;
  color: var(--color-text-primary);
}

.asset-aspect-ratio-item-description {
  font-size: 11px;
  font-weight: 500;
  color: var(--color-text-secondary);
}

.asset-aspect-ratio-check {
  color: var(--color-text-primary);
}

.prompt-box-text-button {
  height: 32px;
  padding: 0 10px;
  border-radius: 3px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: inherit;
}

.prompt-box-text-button:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
  border-color: var(--color-text-secondary);
  color: var(--color-text-primary);
}

.prompt-box-text-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.prompt-box-action-button {
  width: 32px;
  height: 32px;
  padding: 0;
  border-radius: 3px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: all 0.15s ease;
}

.prompt-box-action-button:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
  border-color: var(--color-text-secondary);
  color: var(--color-text-primary);
}

.prompt-box-submit-button {
  width: 34px;
  height: 34px;
  padding: 0;
  border-radius: 3px;
  border: 1px solid var(--color-text-primary);
  background: var(--color-text-primary);
  color: var(--color-bg-canvas-surface);
  cursor: pointer;
  transition: opacity 0.15s ease;
}

.prompt-box-submit-button:hover:not(:disabled) {
  opacity: 0.9;
}

.prompt-box-submit-button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.prompt-box-actions-below {
  display: flex;
  justify-content: flex-end;
  margin-top: 4px;
}

.prompt-box-uploaded-images {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--color-border-input);
}

.prompt-box-uploaded-item {
  position: relative;
  width: 44px;
  height: 44px;
  border-radius: 2px;
  overflow: hidden;
  border: 1px solid var(--color-border-input);
}

.prompt-box-uploaded-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.prompt-box-remove-image {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 14px;
  height: 14px;
  border-radius: 2px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}

.prompt-box-remove-image:hover {
  background: var(--color-bg-input);
  border-color: var(--color-text-secondary);
}

.prompt-box-mention-badge {
  position: absolute;
  bottom: 2px;
  left: 2px;
  width: 12px;
  height: 12px;
  border-radius: 2px;
  background: var(--color-text-secondary);
  color: var(--color-bg-canvas-surface);
  font-size: 8px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.prompt-box-mention-dropdown {
  min-width: 320px;
  max-width: min(520px, calc(100vw - 32px));
  max-height: 300px;
  overflow-y: auto;
  border-radius: 8px;
  padding: 6px;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-text-secondary);
}

.prompt-box-mention-group + .prompt-box-mention-group {
  margin-top: 5px;
  padding-top: 5px;
  border-top: 1px solid var(--color-border-input);
}

.prompt-box-mention-group-label {
  padding: 5px 8px 4px;
  color: var(--color-text-secondary);
  font-size: 10px;
  font-weight: 800;
  line-height: 1;
  text-transform: uppercase;
  letter-spacing: 0;
}

.prompt-box-mention-category-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.prompt-box-mention-category {
  width: 100%;
  min-height: 38px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 16px;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border: 1px solid transparent;
  border-radius: 4px;
  background: transparent;
  color: var(--color-text-primary);
  cursor: pointer;
  font: inherit;
  text-align: left;
}

.prompt-box-mention-category:hover,
.prompt-box-mention-category.selected,
.prompt-box-mention-category:focus-visible {
  background: var(--color-bg-input);
  border-color: var(--color-border-input);
  outline: none;
}

.prompt-box-mention-category-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 700;
}

.prompt-box-mention-category-arrow {
  color: var(--color-text-secondary);
  font-size: 14px;
  font-weight: 700;
  text-align: right;
}

.prompt-box-mention-item {
  width: 100%;
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  padding: 7px 8px;
  border: 1px solid transparent;
  border-radius: 4px;
  background: transparent;
  color: inherit;
  cursor: pointer;
  font: inherit;
  text-align: left;
}

.prompt-box-mention-item:hover,
.prompt-box-mention-item.selected {
  background: var(--color-bg-input);
  border-color: var(--color-border-input);
}

.prompt-box-mention-item:disabled {
  cursor: wait;
  opacity: 0.7;
}

.prompt-box-mention-thumb {
  width: 34px;
  height: 34px;
  border-radius: 2px;
  border: 1px solid var(--color-border-input);
  object-fit: cover;
}

.prompt-box-mention-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.prompt-box-mention-title {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.prompt-box-mention-name {
  font-size: 12px;
  font-weight: 600;
  color: var(--color-text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.prompt-box-mention-meta {
  min-width: 0;
  font-size: 10px;
  color: var(--color-text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.prompt-box-mention-source {
  flex-shrink: 0;
  padding: 2px 5px;
  border-radius: 3px;
  border: 1px solid var(--color-border-input);
  color: var(--color-text-secondary);
  font-size: 9px;
  font-weight: 800;
  line-height: 1;
  text-transform: uppercase;
  letter-spacing: 0;
}

.prompt-box-mention-context {
  font-size: 10px;
  color: var(--color-text-secondary);
  font-style: italic;
}

.prompt-box-mention-preview {
  display: flex;
  align-items: stretch;
  gap: 8px;
  max-width: min(560px, calc(100vw - 32px));
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  padding: 10px;
}

.prompt-box-mention-preview-main {
  width: 300px;
  max-width: 48vw;
  min-width: 0;
}

.prompt-box-mention-preview-image {
  width: 100%;
  max-height: 240px;
  object-fit: contain;
  border-radius: 2px;
  display: block;
  border: 1px solid var(--color-border-input);
}

.prompt-box-mention-preview-title {
  margin-top: 8px;
  font-size: 12px;
  font-weight: 600;
  color: var(--color-text-primary);
  text-align: center;
}

.prompt-box-mention-preview-meta {
  margin-top: 2px;
  font-size: 11px;
  color: var(--color-text-secondary);
  text-align: center;
}

.prompt-box-mention-preview-context {
  margin-top: 4px;
  font-size: 11px;
  color: var(--color-text-secondary);
  text-align: center;
  font-style: italic;
}

.prompt-box-mention-variations {
  width: 132px;
  max-height: 292px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-left: 8px;
  border-left: 1px solid var(--color-border-input);
}

.prompt-box-mention-variation {
  width: 100%;
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr);
  align-items: center;
  gap: 7px;
  padding: 5px;
  border: 1px solid transparent;
  border-radius: 4px;
  background: transparent;
  color: var(--color-text-primary);
  cursor: pointer;
  font: inherit;
  text-align: left;
}

.prompt-box-mention-variation:hover,
.prompt-box-mention-variation:focus-visible {
  background: var(--color-bg-input);
  border-color: var(--color-border-input);
  outline: none;
}

.prompt-box-mention-variation-image {
  width: 34px;
  height: 34px;
  border-radius: 2px;
  border: 1px solid var(--color-border-input);
  object-fit: cover;
}

.prompt-box-mention-variation-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--color-text-primary);
  font-size: 11px;
  font-weight: 600;
}

.prompt-box-error {
  padding: 10px 14px;
  background: var(--color-bg-user-bubble);
  border: 1px solid var(--color-border-input);
  border-radius: 3px;
  color: var(--color-text-primary);
  font-size: 12px;
  font-weight: 500;
  text-align: center;
}

.prompt-box-drag-hint {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 2px dashed var(--color-border-input);
  color: var(--color-text-secondary);
  background: var(--color-bg-user-bubble);
  pointer-events: none;
  z-index: 10;
}

@media (max-width: 520px) {
  .prompt-box-actions {
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/editor/PromptBox.css"],"names":[],"mappings":"AAAA,mDAAmD;AACnD;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,6EAA6E;EAC7E,uBAAuB;AACzB;;AAEA;EACE,2EAA2E;EAC3E,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,wFAAwF;EACxF,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,WAAW;EACX,SAAS;EACT,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;;;;;;GAOC;EACD,0BAA0B;EAC1B,4DAA4D;AAC9D;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,aAAa;AACf;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,kCAAkC;EAClC,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,qCAAqC;EACrC,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,0CAA0C;EAC1C,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;EAGE,iCAAiC;EACjC,uCAAuC;EACvC,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,iCAAiC;EACjC,uCAAuC;EACvC,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,2CAA2C;EAC3C,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,4CAA4C;EAC5C,kCAAkC;EAClC,uCAAuC;EACvC,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* PromptBox styles - fully scoped to .prompt-box */\n.prompt-box {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  background: transparent;\n  border: none;\n}\n\n.prompt-box--dragging {\n  background: transparent;\n  border: none;\n}\n\n.prompt-box-form {\n  width: 100%;\n  max-width: 700px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.prompt-box-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.prompt-box-label {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--color-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.prompt-box-field {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 12px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n}\n\n.prompt-box--resizable .prompt-box-field {\n  position: relative;\n  gap: 0;\n  /* Top/sides stay matched; add a little extra room before the bottom border */\n  padding: 14px 14px 18px;\n}\n\n.prompt-box--resizable .prompt-box-textarea {\n  /* Tight line box so the first line's ink aligns closer to the left inset */\n  line-height: 1;\n  padding: 0;\n}\n\n.prompt-box-resize-handle {\n  position: absolute;\n  /* Match the field padding on all sides (absolute positioning is padding-box relative) */\n  top: 0;\n  left: 0;\n  right: 0;\n  width: auto;\n  height: 8px;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: ns-resize;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: auto;\n}\n\n.prompt-box-resize-grip {\n  width: 36px;\n  height: 3px;\n  border-radius: 999px;\n  background: var(--color-border-input);\n  transition: background 0.15s ease;\n}\n\n.prompt-box-resize-handle:hover .prompt-box-resize-grip,\n.prompt-box-resize-handle:focus-visible .prompt-box-resize-grip {\n  background: var(--color-text-secondary);\n}\n\n.prompt-box-field:focus-within {\n  border-color: var(--color-text-secondary);\n}\n\n.prompt-box-input {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n.prompt-box-textarea-wrapper {\n  position: relative;\n}\n\n.prompt-box-textarea {\n  width: 100%;\n  min-height: 120px;\n  max-height: 240px;\n  padding: 0;\n  border: none;\n  border-radius: 0;\n  background: transparent;\n  font-size: 14px;\n  line-height: 1.6;\n  color: var(--color-text-primary);\n  font-family: inherit;\n  resize: none;\n  outline: none;\n  overflow-y: hidden;\n  transition: border-color 0.15s ease, opacity 0.15s ease;\n}\n\n.prompt-box-textarea.enhancing {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.prompt-box-enhancing-overlay {\n  position: absolute;\n  inset: 0;\n  border-radius: 4px;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.prompt-box-enhancing-shimmer {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    90deg,\n    transparent 0%,\n    rgba(255, 255, 255, 0.08) 20%,\n    rgba(255, 255, 255, 0.15) 50%,\n    rgba(255, 255, 255, 0.08) 80%,\n    transparent 100%\n  );\n  background-size: 200% 100%;\n  animation: promptBoxEnhanceShimmer 1.5s ease-in-out infinite;\n}\n\n@keyframes promptBoxEnhanceShimmer {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n.prompt-box-textarea:focus {\n  outline: none;\n}\n\n.prompt-box-textarea::placeholder {\n  color: var(--color-text-secondary);\n}\n\n.prompt-box-actions {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  padding-top: 10px;\n}\n\n.prompt-box-actions > * {\n  flex-shrink: 0;\n}\n\n.prompt-box-actions .model-selector {\n  flex-shrink: 0;\n}\n\n.prompt-box-actions .model-selector-trigger {\n  height: 32px;\n  padding: 0 10px;\n  border-radius: 3px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.prompt-box-actions .model-selector-trigger:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n  border-color: var(--color-text-secondary);\n}\n\n.prompt-box-actions .model-selector-content {\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  box-shadow: none;\n}\n\n.prompt-box-actions .model-selector-item {\n  border-radius: 2px;\n}\n\n.prompt-box-actions .model-selector-item:hover,\n.prompt-box-actions .model-selector-item[aria-selected='true'] {\n  background: var(--color-bg-user-bubble);\n}\n\n.asset-aspect-ratio-picker {\n  flex-shrink: 0;\n}\n\n.asset-aspect-ratio-trigger {\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 0 9px;\n  border-radius: 3px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.asset-aspect-ratio-trigger:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n  border-color: var(--color-text-secondary);\n}\n\n.asset-aspect-ratio-trigger:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.asset-aspect-ratio-swatch,\n.asset-aspect-ratio-item-swatch {\n  display: block;\n  width: 18px;\n  max-height: 18px;\n  min-height: 9px;\n  border: 1px solid currentColor;\n  border-radius: 2px;\n  opacity: 0.72;\n  background: transparent;\n}\n\n.asset-aspect-ratio-value {\n  min-width: 28px;\n  text-align: left;\n}\n\n.asset-aspect-ratio-icon {\n  color: var(--color-text-secondary);\n  transition: transform 0.15s ease;\n}\n\n.asset-aspect-ratio-icon-open {\n  transform: rotate(180deg);\n}\n\n.asset-aspect-ratio-content {\n  min-width: 190px;\n  padding: 4px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.16);\n  z-index: 10000;\n}\n\n.asset-aspect-ratio-item {\n  display: grid;\n  grid-template-columns: 22px minmax(0, 1fr) 16px;\n  align-items: center;\n  gap: 8px;\n  padding: 8px;\n  border-radius: 2px;\n  color: var(--color-text-primary);\n  cursor: pointer;\n  outline: none;\n}\n\n.asset-aspect-ratio-item:hover,\n.asset-aspect-ratio-item[data-highlighted] {\n  background: var(--color-bg-user-bubble);\n}\n\n.asset-aspect-ratio-item-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.asset-aspect-ratio-item-label {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--color-text-primary);\n}\n\n.asset-aspect-ratio-item-description {\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--color-text-secondary);\n}\n\n.asset-aspect-ratio-check {\n  color: var(--color-text-primary);\n}\n\n.prompt-box-text-button {\n  height: 32px;\n  padding: 0 10px;\n  border-radius: 3px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  font-family: inherit;\n}\n\n.prompt-box-text-button:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n  border-color: var(--color-text-secondary);\n  color: var(--color-text-primary);\n}\n\n.prompt-box-text-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.prompt-box-action-button {\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border-radius: 3px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.prompt-box-action-button:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n  border-color: var(--color-text-secondary);\n  color: var(--color-text-primary);\n}\n\n.prompt-box-submit-button {\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  border-radius: 3px;\n  border: 1px solid var(--color-text-primary);\n  background: var(--color-text-primary);\n  color: var(--color-bg-canvas-surface);\n  cursor: pointer;\n  transition: opacity 0.15s ease;\n}\n\n.prompt-box-submit-button:hover:not(:disabled) {\n  opacity: 0.9;\n}\n\n.prompt-box-submit-button:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.prompt-box-actions-below {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 4px;\n}\n\n.prompt-box-uploaded-images {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.prompt-box-uploaded-item {\n  position: relative;\n  width: 44px;\n  height: 44px;\n  border-radius: 2px;\n  overflow: hidden;\n  border: 1px solid var(--color-border-input);\n}\n\n.prompt-box-uploaded-item img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.prompt-box-remove-image {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  width: 14px;\n  height: 14px;\n  border-radius: 2px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n}\n\n.prompt-box-remove-image:hover {\n  background: var(--color-bg-input);\n  border-color: var(--color-text-secondary);\n}\n\n.prompt-box-mention-badge {\n  position: absolute;\n  bottom: 2px;\n  left: 2px;\n  width: 12px;\n  height: 12px;\n  border-radius: 2px;\n  background: var(--color-text-secondary);\n  color: var(--color-bg-canvas-surface);\n  font-size: 8px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.prompt-box-mention-dropdown {\n  min-width: 320px;\n  max-width: min(520px, calc(100vw - 32px));\n  max-height: 300px;\n  overflow-y: auto;\n  border-radius: 8px;\n  padding: 6px;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-text-secondary);\n}\n\n.prompt-box-mention-group + .prompt-box-mention-group {\n  margin-top: 5px;\n  padding-top: 5px;\n  border-top: 1px solid var(--color-border-input);\n}\n\n.prompt-box-mention-group-label {\n  padding: 5px 8px 4px;\n  color: var(--color-text-secondary);\n  font-size: 10px;\n  font-weight: 800;\n  line-height: 1;\n  text-transform: uppercase;\n  letter-spacing: 0;\n}\n\n.prompt-box-mention-category-list {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.prompt-box-mention-category {\n  width: 100%;\n  min-height: 38px;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 16px;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  background: transparent;\n  color: var(--color-text-primary);\n  cursor: pointer;\n  font: inherit;\n  text-align: left;\n}\n\n.prompt-box-mention-category:hover,\n.prompt-box-mention-category.selected,\n.prompt-box-mention-category:focus-visible {\n  background: var(--color-bg-input);\n  border-color: var(--color-border-input);\n  outline: none;\n}\n\n.prompt-box-mention-category-name {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.prompt-box-mention-category-arrow {\n  color: var(--color-text-secondary);\n  font-size: 14px;\n  font-weight: 700;\n  text-align: right;\n}\n\n.prompt-box-mention-item {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 34px minmax(0, 1fr);\n  align-items: center;\n  gap: 10px;\n  padding: 7px 8px;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n  font: inherit;\n  text-align: left;\n}\n\n.prompt-box-mention-item:hover,\n.prompt-box-mention-item.selected {\n  background: var(--color-bg-input);\n  border-color: var(--color-border-input);\n}\n\n.prompt-box-mention-item:disabled {\n  cursor: wait;\n  opacity: 0.7;\n}\n\n.prompt-box-mention-thumb {\n  width: 34px;\n  height: 34px;\n  border-radius: 2px;\n  border: 1px solid var(--color-border-input);\n  object-fit: cover;\n}\n\n.prompt-box-mention-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.prompt-box-mention-title {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n.prompt-box-mention-name {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.prompt-box-mention-meta {\n  min-width: 0;\n  font-size: 10px;\n  color: var(--color-text-secondary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.prompt-box-mention-source {\n  flex-shrink: 0;\n  padding: 2px 5px;\n  border-radius: 3px;\n  border: 1px solid var(--color-border-input);\n  color: var(--color-text-secondary);\n  font-size: 9px;\n  font-weight: 800;\n  line-height: 1;\n  text-transform: uppercase;\n  letter-spacing: 0;\n}\n\n.prompt-box-mention-context {\n  font-size: 10px;\n  color: var(--color-text-secondary);\n  font-style: italic;\n}\n\n.prompt-box-mention-preview {\n  display: flex;\n  align-items: stretch;\n  gap: 8px;\n  max-width: min(560px, calc(100vw - 32px));\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  padding: 10px;\n}\n\n.prompt-box-mention-preview-main {\n  width: 300px;\n  max-width: 48vw;\n  min-width: 0;\n}\n\n.prompt-box-mention-preview-image {\n  width: 100%;\n  max-height: 240px;\n  object-fit: contain;\n  border-radius: 2px;\n  display: block;\n  border: 1px solid var(--color-border-input);\n}\n\n.prompt-box-mention-preview-title {\n  margin-top: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  text-align: center;\n}\n\n.prompt-box-mention-preview-meta {\n  margin-top: 2px;\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  text-align: center;\n}\n\n.prompt-box-mention-preview-context {\n  margin-top: 4px;\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  text-align: center;\n  font-style: italic;\n}\n\n.prompt-box-mention-variations {\n  width: 132px;\n  max-height: 292px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding-left: 8px;\n  border-left: 1px solid var(--color-border-input);\n}\n\n.prompt-box-mention-variation {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 34px minmax(0, 1fr);\n  align-items: center;\n  gap: 7px;\n  padding: 5px;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  background: transparent;\n  color: var(--color-text-primary);\n  cursor: pointer;\n  font: inherit;\n  text-align: left;\n}\n\n.prompt-box-mention-variation:hover,\n.prompt-box-mention-variation:focus-visible {\n  background: var(--color-bg-input);\n  border-color: var(--color-border-input);\n  outline: none;\n}\n\n.prompt-box-mention-variation-image {\n  width: 34px;\n  height: 34px;\n  border-radius: 2px;\n  border: 1px solid var(--color-border-input);\n  object-fit: cover;\n}\n\n.prompt-box-mention-variation-name {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--color-text-primary);\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.prompt-box-error {\n  padding: 10px 14px;\n  background: var(--color-bg-user-bubble);\n  border: 1px solid var(--color-border-input);\n  border-radius: 3px;\n  color: var(--color-text-primary);\n  font-size: 12px;\n  font-weight: 500;\n  text-align: center;\n}\n\n.prompt-box-drag-hint {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  border: 2px dashed var(--color-border-input);\n  color: var(--color-text-secondary);\n  background: var(--color-bg-user-bubble);\n  pointer-events: none;\n  z-index: 10;\n}\n\n@media (max-width: 520px) {\n  .prompt-box-actions {\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
